import Image from '@next/image';
import classNames from 'classnames';

import Typography from '@components/atoms/Typography';
import Message from 'types/Message';
import { ResolveConfig } from 'utils/resolveImageUrl';

import classes from './BadgeInfo.module.scss';

type Props = {
  description?: Message;
  iconAlt: string;
  resolveConfig?: ResolveConfig;
  className?: string;
};

const BadgeInfo = ({ resolveConfig, iconAlt, description, className }: Props): JSX.Element => (
  <div className={classNames(className, classes.wrapper)}>
    {resolveConfig && (
      <Image className={classes.image} alt={iconAlt} objectFit="contain" resolveConfig={resolveConfig} />
    )}
    <Typography variant="h4" renderAs="div" align="center">
      {description}
    </Typography>
  </div>
);

export default BadgeInfo;
